import { useIntl } from "react-intl";
import HeaderList from "../../HeaderList";
import BodyList from "../../BodyList";
import { Spin } from "antd";
import Empty from "../../../common/Empty";

const ListOfReservations = ({ data, setPage, isLoading, page }: any) => {
  const intl = useIntl();
  const cols = [
    intl.formatMessage({ id: "orderNumber" }), // for "id"
    intl.formatMessage({ id: "creationDate" }), // for "date"
    intl.formatMessage({ id: "status" }), // for "status"
    intl.formatMessage({ id: "submissionDate" }), // for "created_at"
    intl.formatMessage({ id: "cancellationDate" }), // for "cancellation_date"
    intl.formatMessage({ id: "client" }), // for "client_name"
    intl.formatMessage({ id: "team" }), // for "team_name"
    intl.formatMessage({ id: "duration" }), // for "duration"
    intl.formatMessage({ id: "servicesNumber" }), // for "services_count"
  ];
  const PagePagination = (page: any, pageSize: any) => {
    console.log(`Currently on page: ${page} with page size: ${pageSize}`);
    // Fetch new data based on 'page' or do other effects
    setPage(page);
  };
  console.log(data);

  return isLoading ? (
    <Spin className="flex items-center justify-center" />
  ) : data?.data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={data?.data}
        page={page}
        total={data?.total}
        setPage={setPage}
      />
    </div>
  ) : (
    <Empty title="لا توجد" subTitle="" />
  );
};

export default ListOfReservations;
